module.exports = __webpack_public_path__ + "static/img/tabela.e94fa00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/limao/tabela.png
// module id = OiCv
// module chunks = 0